/**
* @description 动态插入script
*/
export function insertScriptDynamically(src: string, onload?: (() => any) | undefined) {
  const s = window.document.createElement('script');
  s.type = 'text/javascript';
  s.src = src;
  s.onload = function() {
    onload && onload();
  };
  window.document.body.appendChild(s);
}
